<div class="events-table-option">
  <div class="contact-table-top-panel">
    <div class="contact-table-top-panel-left">
      <div class="date-section-line">
        <span>{{dateDateView}}</span>
        <i #openCalendar class="fas fa-calendar-alt open-calendar" (click)="openPicker()"></i>
      </div>

    </div>
    <div class="contact-table-top-panel-right">
      <div class="total-found-info">
        <span class="total-found-info-label" translate="CONTACTS_LIST.FOUND"></span>
        <span class="total-found-info-value"> {{total}} </span>
        <span class="total-found-info-value">
          {{(total === 1) ? 'EVENT' : 'EVENTS' | translate }}
          </span>
      </div>
      <form action="" class="pagination-selector">
        <div class="pagination-selector-label" translate>SHOW</div>
        <mat-form-field>
          <mat-select [(ngModel)]="page.pagination.limit" name="pagination"
                      (selectionChange)="changePagination($event)">
            <mat-option *ngFor="let pag of paginationOptions" [value]="pag">
              {{pag}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <button
        class="filters-button contact-table-top-panel-button"
        (click)="addFilter()"
        color="primary-full">
          <span>
            <i class="fas fa-filter"></i>
          </span>
        <div class="filter-counter" *ngIf="tempEditedFiltersList.length">
          <span>{{tempEditedFiltersList.length}}</span>
        </div>
      </button>
    </div>
  </div>

  <ngx-datatable #myTable
                 class="material contact-table events-table"
                 [rows]="rows"
                 [columns]="columns"
                 [columnMode]="'force'"
                 [headerHeight]="49"
                 [summaryRow]="false"
                 [summaryPosition]="'bottom'"
                 [footerHeight]="total > filterParams.pagination.limit ? 40 : 0"
                 [rowHeight]="60"
                 [scrollbarH]="true"
                 [reorderable]="reorderable"
                 [swapColumns]="swapColumns"
                 [selectAllRowsOnPage]="false"
                 [displayCheck]="displayCheck"
                 [externalSorting]="true"
                 (sort)="onSort($event)"
                 (select)="onSelect($event)"
                 [rowIdentity]="getRowIdentity"
                 [externalPaging]="true"
                 [limit]="filterParams.pagination.limit"
                 (page)="setPage($event)"
                 [count]="total"
                 [offset]="tableOffset"
                 [loadingIndicator]="loadingIndicator"
                 [messages]="messages"
                 (activate)="onActivate($event)"
  >
    <!-- Row Detail Template was here -->

    <!-- First HEADER column with buttons -->
    <ngx-datatable-column name=""
                          [width]="0"
                          [resizeable]="true"
                          [sortable]="false"
                          [draggable]="false"
                          [canAutoResize]="false"
                          [frozenLeft]="true">
      <ng-template let-column="column" ngx-datatable-header-template>
      </ng-template>
    </ngx-datatable-column>
    <!-- end of first HEADER with buttons -->

    <!-- Column Templates -->
    <!-- first one -->
    <ngx-datatable-column
      name=""
      [width]="10"
      [resizeable]="false"
      [sortable]="false"
      [draggable]="false"
      [canAutoResize]="false"
      [frozenLeft]="true">

      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template >
        <a [routerLink]="'/event-details/' + row.event_id"
           [title]="'CONTACTS_LIST.DETAILS' | translate"
           class="event-details-link-wrapper">
          <div class="event-details "[class.visible]="activeEvent === row.event_id">
            <i class="material-icons info" >info</i>
          </div>
        </a>
      </ng-template>
    </ngx-datatable-column>


    <!-- the rest of generic columns-->
    <ngx-datatable-column
      *ngFor="let col of columns"
      [prop]="col.key"
      [name]="col.name | translate"
      [width]="columnWidth"
      [frozenLeft]="col.frozenLeft"
      [sortable]="col.key.startsWith('NATIVE') && col.key !== 'NATIVE_CLIENT_PHONE_NUMBER' ">
      <ng-template let-row="row"
                   *ngIf="col.key === 'NATIVE_CLIENT_PHONE_NUMBER'"
                   ngx-datatable-cell-template
      >
        <span *ngIf="row[col.key][0] && row[col.key][0].isoCountry" class="flag-icon m-r-xs"
              [ngClass]="'flag-icon-'+ row[col.key][0].isoCountry"></span>
        <span *ngIf="row[col.key][0] && row[col.key][0].msisdn" class="msisdn-wrapper">
          <span *ngIf="col.key === 'NATIVE_CLIENT_PHONE_NUMBER'"
                [title]="row[col.key][0].msisdn"
                class="clickable-number">{{row[col.key][0].msisdn | phoneNumber}}</span>
          <cc-call-icon
            *ngIf="row[col.key] && row[col.key].length && row[col.key][0].isoCountry"
            [number]="row[col.key][0].msisdn"></cc-call-icon>
        </span>
      </ng-template>

      <ng-template let-row="row"
                   *ngIf="col.key === 'NATIVE_AGENT'"
                   ngx-datatable-cell-template>
        <div class="contact-table-details-cell">
          <cc-flag-label-item
            [label]="row[col.key].agentLogin"
            [number]="row[col.key].agentNumber && row[col.key].agentNumber.msisdn"
            [numberLabel]="row[col.key].agentNumber && row[col.key].agentNumber.label"
            [empty]="'UNASSIGNED'">
          </cc-flag-label-item>
        </div>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_EVENT_DATE'" ngx-datatable-cell-template>
        <span [title]="getDateFormated(row[col.key])">{{getDateFormated(row[col.key])}}</span>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_EVENT_TYPE'" ngx-datatable-cell-template>
        <span
          [title]="getEventTypeLabel(row[col.key]) | translate">{{getEventTypeLabel(row[col.key]) | translate}}</span>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_CALL_LENGTH'" ngx-datatable-cell-template>
        <span [title]="getCallLengthLabel(row[col.key])">{{getCallLengthLabel(row[col.key])}}</span>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_DETAILS'" ngx-datatable-cell-template>
        <div *ngIf="row.related_contacts && row.related_contacts.length === 1"
             class="contact-table-details-cell">
          <a [href]="'/contact-details/' + row.contact_id + '/0'">
            <div class="details-name" [title]="getContactNamePhrase(row.related_contacts[0])">
            {{getContactNamePhrase(row.related_contacts[0]) | translate}}</div>
            <div class="details-email" *ngIf="row.related_contacts[0].email && row.related_contacts[0].email"
               [title]="row.related_contacts[0].email">{{row.related_contacts[0].email}}</div>
          </a>
        </div>
        <div *ngIf="row.related_contacts && row.related_contacts.length > 1"
             class="contact-table-details-cell">
          <a [href]="'/contact-details/' + row.contact_id + '/0'">
            <div class="details-name">{{'CONTACTS_LIST.VARIOUS_CONTACTS' | translate}}</div>
            <div class="details-email" >{{row.related_contacts[0].email}}</div>
          </a>
        </div>
        <cc-contact-tooltip
          *ngIf="row.related_contacts && row.related_contacts.length > 1"
          [documents]="getRelatedContactNames(row.related_contacts)"
        ></cc-contact-tooltip>
      </ng-template>
      <ng-template let-row="row" *ngIf="col.key === 'NATIVE_TAGS'" class="tag-row" ngx-datatable-cell-template>
        <div class="table-cell-tag-wrapper">
          <div *ngFor="let tag of row[col.key]" class="table-cell-tag">
            {{tag}}
          </div>
        </div>
        <div class="tag-editor-opener table-cell-tag">
          <i class="material-icons tag-editor-opener-icon">
            more_horiz
          </i>
        </div>
      </ng-template>
    </ngx-datatable-column>

    <!-- last HEADER column with buttons -->
    <!--  <ngx-datatable-column name="" [width]="160" [frozenRight]="true">-->
    <!--    <ng-template let-column="column" ngx-datatable-header-template>-->
    <!--      <a href="#" (click)="buttonClick($event)" class="layer-button-add temporary-hidden">-->
    <!--        <i class="material-icons add-layer-icon">add</i>-->
    <!--        <span>{{'CONTACTS_LIST.ADD_LAYER' | translate}}</span>-->
    <!--      </a>-->
    <!--      <a href="#"  class="table-header-button eye-icon-wrapper temporary-hidden" (click)="buttonClick($event)">-->
    <!--        <i class="material-icons add-layer-icon">remove_red_eye</i>-->
    <!--      </a>-->
    <!--    </ng-template>-->
    <!--  </ngx-datatable-column>-->
    <!-- end of HEADER with buttons -->

  </ngx-datatable>
</div>

